/*
 * Fig & Bloom — recently viewed dock. Markup, styles and the why:
 * snippets/fb-recently-viewed-dock.liquid.
 */
(function () {
  var dock = document.getElementById('fb-rv-dock');
  if (!dock) return;

  var KEY = 'shopify-recent-view';
  var handles = [];
  try {
    handles = (localStorage.getItem(KEY) || '').split(',').filter(Boolean).reverse(); // newest first
  } catch (e) {}
  if (!handles.length) return; // nothing viewed yet: no dock at all

  var toggle = dock.querySelector('.fb-rv-toggle');
  var tray = dock.querySelector('.fb-rv-tray');
  var list = dock.querySelector('[data-fb-rv-list]');
  var countEl = dock.querySelector('[data-fb-rv-count]');
  var body = document.body;

  function setCount(n) { countEl.textContent = ' (' + n + ')'; }
  setCount(handles.length);
  dock.hidden = false;

  // ── Height, for the back-to-top to stack on ────────────────────────────────
  // --fb-rv-h is the dock's own border box, never the tab-bar clearance (that
  // would lift the arrow twice). A zero read happens while the dock is still
  // display:none — a landscape rotation, before the phone media query applies
  // — and publishing it would pin the arrow under the bar for the rest of the
  // page. Skip it; the CSS floor is the collapsed 49px until a real height
  // arrives.
  function publishHeight() {
    if (!dock.offsetHeight) return;
    body.style.setProperty('--fb-rv-h', dock.offsetHeight + 'px');
    placeScrollButton();
  }
  publishHeight();

  // The shown dock stays on translateY(0), so Safari can composite it above
  // the layout box --fb-rv-h describes. Read the painted top and hold the
  // arrow and the bottom pill 16px above that. The pill is .rw-pill (the
  // white Reminders bar that replaced "On the list"); [data-sp-widget] is
  // that spot when Reminders is off. Only once the slide has settled:
  // mid-transition the rect is still off the bottom of the screen.
  function dockIsResting() {
    var t = getComputedStyle(dock).transform;
    if (!t || t === 'none') return true;
    var m = /^matrix\(([^)]+)\)$/.exec(t);
    if (m) return Math.abs(parseFloat(m[1].split(',')[5])) < 0.5;
    var m3 = /^matrix3d\(([^)]+)\)$/.exec(t);
    if (m3) return Math.abs(parseFloat(m3[1].split(',')[13])) < 0.5;
    return false;
  }
  function placeAboveDock(el) {
    if (!el) return;
    if (!body.classList.contains('fb-rv-up') || dock.hidden || !dockIsResting()) {
      if (!body.classList.contains('fb-rv-up')) el.style.removeProperty('bottom');
      return;
    }
    var top = dock.getBoundingClientRect().top;
    // Same viewport an element's own `bottom` is measured against. Adding
    // visualViewport.offsetTop here lifts it by that offset again.
    var viewportHeight = window.innerHeight;
    if (!(top < viewportHeight)) return;
    var bottom = Math.round(viewportHeight - top + 16);
    if (!isFinite(bottom)) return;
    el.style.bottom = bottom + 'px';
  }
  function placeScrollButton() {
    placeAboveDock(document.getElementById('scroll__top'));
    placeAboveDock(document.querySelector('[data-sp-widget]'));
    placeAboveDock(document.querySelector('.rw-pill'));
    placeAboveDock(document.querySelector('.rw-nudge'));
  }
  function onViewportChange() {
    publishHeight();
  }
  window.addEventListener('resize', onViewportChange, { passive: true });
  window.addEventListener('orientationchange', onViewportChange);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', onViewportChange, { passive: true });
  }
  dock.addEventListener('transitionend', function (event) {
    if (event.target === dock && event.propertyName === 'transform') placeScrollButton();
  });

  // ── Show on scroll up, tuck away on scroll down ────────────────────────────
  var SHOW_BELOW = 400;
  var JITTER = 8;
  var lastY = window.scrollY;
  var ticking = false;

  function setShown(on) {
    if (dock.classList.contains('fb-rv-shown') === on) return;
    dock.classList.toggle('fb-rv-shown', on);
    body.classList.toggle('fb-rv-up', on);
    if (!on) setOpen(false);
    else placeScrollButton();
    // The slide eases the dock up. Place again once it has moved, and once
    // more on the next frame for a reduced-motion jump that never fires
    // transitionend.
    requestAnimationFrame(function () { requestAnimationFrame(placeScrollButton); });
  }

  function onScroll() {
    ticking = false;
    var y = window.scrollY;
    var delta = y - lastY;
    if (y < SHOW_BELOW) setShown(false);
    else if (delta < -JITTER) setShown(true);
    else if (delta > JITTER) setShown(false);
    if (Math.abs(delta) > JITTER) lastY = y;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
  }, { passive: true });

  // ── Open / close ────────────────────────────────────────────────────────────
  // The tiles are built ahead of time, in the background (see prefetch below),
  // so opening the tray shows photos at once. Opening before that has finished
  // just starts it early.
  var loaded = false;

  function setOpen(open) {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    tray.classList.toggle('fb-rv-tray-open', open);
    tray.toggleAttribute('inert', !open);
    if (open && !loaded) load();
    publishHeight();
  }

  toggle.addEventListener('click', function () {
    setOpen(toggle.getAttribute('aria-expanded') !== 'true');
  });

  // The tray's own height eases open/closed (see the .fb-rv-tray-open
  // transition), so re-measure once that settles rather than mid-animation.
  tray.addEventListener('transitionend', function (event) {
    if (event.target === tray && event.propertyName === 'max-height') publishHeight();
  });

  function sized(src, width) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function load() {
    loaded = true;
    list.innerHTML = '<li><p class="fb-rv-status">Loading…</p></li>';
    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      // A handle for a product since removed or unpublished comes back empty.
      var found = products.filter(function (p) { return p && p.url; });
      list.innerHTML = '';
      found.forEach(function (p) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'fb-rv-tile';
        a.href = p.url;
        var img = document.createElement('img');
        img.src = sized(p.featured_image, 160);
        img.alt = p.title;
        img.width = 64;
        img.height = 80;
        // Eager, not lazy: the tray is hidden while this runs, and a lazy image
        // in a hidden tray would wait to be opened before downloading, which is
        // the delay this is here to remove.
        img.loading = 'eager';
        img.decoding = 'async';
        a.appendChild(img);
        li.appendChild(a);
        list.appendChild(li);
      });
      setCount(found.length);
      if (!found.length) {
        list.innerHTML = '<li><p class="fb-rv-status">Nothing to show yet.</p></li>';
      }
      publishHeight();
    });
  }

  // ── Prefetch ────────────────────────────────────────────────────────────────
  // Once the page has settled, fetch the products and their photos quietly so
  // the tray is ready before anyone opens it. Phones only, where the dock is
  // shown; up to ten small JSON requests and 160px images, after the page's own
  // work is done.
  function prefetch() {
    if (loaded) return;
    if (window.matchMedia && !window.matchMedia('(max-width: 991px)').matches) return;
    load();
  }
  function whenIdle() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(prefetch, { timeout: 4000 });
    else setTimeout(prefetch, 1500);
  }
  if (document.readyState === 'complete') whenIdle();
  else window.addEventListener('load', whenIdle);
})();
